module.exports = __webpack_public_path__ + "img/logoList.f19ae987.svg";